var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"o-list-bare side-menu"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"side-menu__item"},[_c('button-menu',{attrs:{"icon":item.icon,"text":item.text,"active":item.active}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }